export const columns = function () {
    return [
        {
            prop: 'personName',
            label: '名称',
        },
        {
            prop: 'certNo',
            label: '证件号',
            privacyType: true
        },
        {
            prop: 'tel',
            label: '电话',
        },
        {
            prop: 'email',
            label: '邮箱',
        },
        {
            prop: 'addr',
            label: '地址',
        },
        {
            prop: 'handle',
            label: '操作',
            width: 150
        }
    ]
}

export default {}